import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/bluedolphin.webp';
import screenshot_target from '../../../images/letterfunnel/jellevisser.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jelle Visser"
      firstname="Jelle"
      companyname="BlueDolphin"
      competition="Bizzdesign en Mavim"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jellevisser.js